





































































import { Component, Vue, Watch } from 'vue-property-decorator';
import store from '@/store';
import MainLayout from '@/layouts/Main.vue';
import { Lang } from '@/lang/en/maps.ts';
import GMapsConfig from '@/configs/gMapsConfig';
import LocationsService from '@/services/locations';
import CategoriesService from '@/services/categories';

@Component({
  components: {
    MainLayout,
  },
})
export default class Map extends Vue {
  private lang: object = Lang;
  private mapId: string = 'mapContainer';
  private zoomLevel: number = 14.52;
  private zoomable: boolean = false;
  private mapPosition: object = GMapsConfig.MapConfig.center;
  private isLoaded: boolean = false;
  private clonedLocations: any = [];
  private clonedCategories: any = [];
  private activeLocation: any = {};
  private iwOpen: boolean = false;
  private iwOptions: any = {};
  private mapCategories: any;
  private originalLocations: any = [];

  private beforeCreate() {
    LocationsService.Get();
    CategoriesService.Get();
  }

  get getMapStyle() {
    return 'width:100%;  height: 80vh;';
  }

  get locations() {
    return store.getters['Locations/getCurrentLocations'];
  }

  get categories() {
    return store.getters['Categories/getCategories'];
  }

  private goToEdit(id: number) {
    this.$router.push({ name: 'locations.edit',  params: { id: id.toString() } });
  }

  private iwClose() {
    this.iwOpen = false;
  }

  private categoriesSelect(): void {
    this.clonedLocations = this.originalLocations.filter((location) => {
      for (const category of this.mapCategories) {
        if (location.category.some((v) => {
          return v.id === category;
        })) { return true; }
      }
    });
    this.iwClose();
  }

  private setActiveLocation(location: any): void {
    this.activeLocation = {...location};
    this.mapPosition = { lat: this.activeLocation.latitude, lng: this.activeLocation.longitude };
    this.iwOptions = { pixelOffset: { width: 0, height: -40 }};
    this.iwOpen = !this.iwOpen;
  }

  @Watch('locations')
  private onLocationsChange() {
    this.isLoaded = true;
    this.clonedLocations = [...this.locations];
    this.originalLocations = this.clonedLocations;
  }

  @Watch('categories')
  private onCategoriesChange() {
    this.clonedCategories = [...this.categories];
    this.mapCategories = this.clonedCategories;
  }
}
